import React from "react";
import { useLazyGetClientReviewSummaryQuery } from "../../../../services/clientreviews";
import { ClientReviewSummaryViewModel } from "../types";

export type UseClientReviewsSummaryHookProps = {
    results : ClientReviewSummaryViewModel[],
    totalCount : number,
    isError : boolean,
    error : Error | string | null,
    isNextPageLoading : boolean,
    hasMore : boolean,
    clear: () => void,
    loadMore: () => void,
    reload: (e : any) => void
};

export const useClientReviewsSummary = (masterAccountId, initLimit = 25) : UseClientReviewsSummaryHookProps => {

    const [limit, setLimit] = React.useState(initLimit);
    const [cacheKey, setCacheKey] = React.useState(new Date().valueOf());
    const [load, { data, isLoading, isFetching, isError, error, isUninitialized }] = useLazyGetClientReviewSummaryQuery();

    const { pagination, results } = data || { pagination: { page: 1, pageSize: limit, totalCount: 0, totalPages: 1 }, results: [] };
    const { page, totalCount, totalPages } = pagination;
    const hasMore = totalCount > 0 && page < totalPages;
    const isNextPageLoading = isFetching === true || isLoading === true;

    const clear = () => {
         // safety check to make sure we don't reload when already loading!
         if (isNextPageLoading) {
            return;
        }

        const newCacheKey = new Date().valueOf();
        load({
            cacheKey: newCacheKey,
            masterAccountId,
            limit,
            page: 1,
        }).unwrap().then(_ => {
            setCacheKey(_ => newCacheKey)
        });
    };

    const reload = (e) => {
        if (e && typeof e.preventDefault === "function") {
            e.preventDefault();
        }

        clear();
    };

    const loadMore = () => {
        // safety check to make sure we don't reload when already loading!
        if (isNextPageLoading) {
            return;
        }

        load({
            cacheKey,
            masterAccountId,
            limit,
            page: page + 1
        });
    };  


    React.useEffect(clear, []);

    return {
        results,
        totalCount,
        isError,
        error,
        isNextPageLoading,
        hasMore,
        clear,
        loadMore,
        reload,
    };
}